import LocalStorage from "../LocalStorage";
import {isDefined} from "../../../utils/Utils";

/**
 * Users list filters
 */
export class UsersListFilter {
	constructor(public hideInactiveUsers: boolean) {}

	static empty(): UsersListFilter {
		return new UsersListFilter(true);
	}

	/**
	 * Parse local storage data.
	 * @param data data to parse.
	 * @returns {UsersListFilter}
	 */
	static getFromLocalStorageData(data: any): UsersListFilter {
		if (!isDefined(data)) {
			return UsersListFilter.empty();
		}
		const hideInactiveUsers = isDefined(data.hideInactiveUsers) ? data.hideInactiveUsers : true;
		return new UsersListFilter(hideInactiveUsers);
	}

	updateInactiveUsers(value: boolean): UsersListFilter {
		this.hideInactiveUsers = value;
		LocalStorage.saveUsersListFilters(this);
		return this;
	}
}
